export default __webpack_public_path__ + "static/media/host_managerId.a299b70c.svg";